Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityTableHeaderView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_table_header']
  className: 'operator-availability-table-row operator-availability-table-header'

  initialize: ({pendingIncluded}) =>
    @pendingIncluded = pendingIncluded

  render: =>
    @$el.html(@template({
      pendingIncluded: @pendingIncluded,
      averageAttentionTimeTooltip: I18n.t('customer.reports.operator_availability.average_attention_time_tooltip')
    }))
    @
